import React from 'react'
import { useUIStore } from '../../store/ui'
import Sidebar from './Sidebar'
import Header from './Header'
import { clsx } from 'clsx'

interface LayoutProps {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { isSidebarOpen, isMobile } = useUIStore()

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar */}
      <Sidebar />

      {/* Mobile overlay */}
      {isMobile && isSidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden"
          onClick={() => useUIStore.getState().setSidebarOpen(false)}
        />
      )}

      {/* Main content area */}
      <div className="flex-1 flex flex-col min-w-0">
        <Header />
        
        <main 
          className={clsx(
            'flex-1 overflow-auto',
            'transition-all duration-300 ease-in-out',
            isMobile ? 'p-4' : 'p-6'
          )}
        >
          <div className="max-w-7xl mx-auto">
            {children}
          </div>
        </main>
      </div>
    </div>
  )
}

export default Layout